import script from "./ViewEditBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewEditBlock.vue?vue&type=script&setup=true&lang=js"

import "./ViewEditBlock.vue?vue&type=style&index=0&id=6c9f94ae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c9f94ae"]])

export default __exports__